import { Button, Typography } from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { CSSProperties } from "react";

export default function UploadFileButtonShort ({ style, width, height, onClick }: { style?: CSSProperties, width?: string | number, height?: string | number, onClick: Function }) {
    return (
        <div onClick={() => onClick()} style={{ width: width ? width : '200px', height: height ? height : '40px', margin: '0px 15px', borderStyle: 'dashed', borderRadius: '10px', color: 'grey', borderWidth: '1px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', ...style }}>
            <Typography style={{ fontWeight: '600', fontSize: '13px', marginLeft: '5px', placeContent: 'center', color: 'var(--color-gray)' }}>Carregar Documento</Typography>
            <FileUploadIcon style={{ fontSize: '20px', color: 'var(--color-gray)' }} />
        </div>
    )
}